import { render } from "./AttendanceClassesAdd.vue?vue&type=template&id=39487c96&scoped=true"
import script from "./AttendanceClassesAdd.vue?vue&type=script&lang=js"
export * from "./AttendanceClassesAdd.vue?vue&type=script&lang=js"

import "./AttendanceClassesAdd.vue?vue&type=style&index=0&id=39487c96&lang=less&scoped=true"
import "./AttendanceClassesAdd.vue?vue&type=style&index=1&id=39487c96&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39487c96"]])

export default __exports__